// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"JP-z","inlineTitle":"KP-z","sponsoredAdsWrapper":"LP-z","marketplaceRecosWrapper":"MP-z"};